// Quotation.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Formik, Form, FieldArray, validateYupSchema, yupToFormErrors } from "formik";
import { buildPopsRows, applyPopRegionChange, buildGrxBandwidthRows, applyTransportChange, applySigtranChange, applyDiameterChange, applyDnsChange, buildSigtranMsusRow, buildDiameterTransactionRow, applyHttpChange, buildHttpRow } from "./quotationRules";
import Accordion from "../../../../components/accordion/Accordion"; import styles from "./quotation.module.css";
import { BackButton, Submit } from "../../../../components/button/buttons";
import { ACCORDIAN_TITLE, bandwidthOptions, connectionOptions, currencyOptions, grxTransportOptions, portSizeOptions, sortQuotationRows, TYPE, quotationSchema, DEMAND_ACTIONS, ACTION_STATUS, Quotation_SUBTAB, QUOTATION_CONFIG, VALID_QUOTATION_STATUSES, minimumContractPeriod, QUOTATION_PDF_ALLOWED_STATUSES_FOR_CUSTOMER, getDownloadConfig, SELECTION_VALUES } from "../../../../utils/constants/DemandConstant";
import IMAGES from "../../../../assets/images/images";
import { DateTimeTextField, SelectField, TextField } from "../../controllers/quotationControllers";
import { formatDate, formatDateInDMY, generateId, generateQuotationPDF, getLabelFromValue } from "../../../../utils/arrayUtils";
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from "../../../../utils/constants/userConstants";
import DecisionModal from "../decisionTemplate/DecisionModal";
import { useParams } from "react-router-dom";
import { QuotationStatus } from "../progressTemplate/progressIndicator";
import HistoryPanel from "../historyPanel/historyPanel";
import { toTitleCase } from "../../../../utils/utils";
import CAN from '../../../../casl/can';
import { Action, Resource } from '../../../../casl/constants';
import { ConfirmDialog } from "../../../../hooks/confirmDialog/confirmDialog";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { connect } from "react-redux";
import DatePickerField from "../../../../components/datePicker/DatePickerField";

const Quotation =({historyData,actionStatus,quotationData:InitialData,floorPriceActiveData,activeTab,regionOptions,...props })=> {
  const [quotationData,setQuotationData]=useState(InitialData);
  let { requestId } = useParams();
  const canCreateFlorPrice = CAN(Action.CREARE_FLOORPRICING, Resource.D2C_DEMANDS);
  const canAddMargin= CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS);
  const isCustomer = props?.myRights?.userType === USER_TYPE.CUSTOMER;
  const downloadConfig = getDownloadConfig({status: quotationData?.status,userType : props?.myRights?.userType});
  const activeConfig = downloadConfig[activeTab];
  const formikRef = useRef(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isPreview, setIsPreview] = useState(canAddMargin?true:false);
  const canEditAll = canCreateFlorPrice && actionStatus === ACTION_STATUS.QUOTATION_FLOOR_PRICING_INITIATED;
  const canEditQuotationOnly = canAddMargin && actionStatus === ACTION_STATUS.QUOTATION_MARGIN_INITIATED;
  const isWorkflowReadOnly = isCustomer || actionStatus === ACTION_STATUS.QUOTATION_CUSTOMER_APPROVAL_INITIATED || (!canEditAll && !canEditQuotationOnly);
  const effectivePreview = isWorkflowReadOnly || isPreview;
  const summaryReadOnly = effectivePreview || !canEditAll;
  const serviceConfigReadOnly = effectivePreview || !canEditAll;
  const quotationReadOnly = effectivePreview || !(canEditAll || canEditQuotationOnly);
  const [decisionModal, setDecisionModal] = useState(null);
  const status = quotationData?.status;
  const config = QUOTATION_CONFIG[status];
  
  useEffect(()=>{
    setQuotationData(InitialData);
  },[InitialData])

  const onViewQuote=(historydata)=>{
    setIsPreview(true);
    setQuotationData(historydata);
  }

  useEffect(() => {
  if (!formikRef.current) return;
  if (quotationData?.quotation?.rows?.length > 0) {
  return;
  }
  const values = formikRef?.current?.values;
  const pops = values?.serviceConfig?.ipAccessStandardConnection?.popsDetails || [];
  const grx = values?.serviceConfig?.IpxGrxTransport?.bandwidths || [];

  let rebuilt = buildPopsRows(pops, values?.quotation?.rows,regionOptions);
  rebuilt = buildGrxBandwidthRows(grx, rebuilt);

  if (JSON.stringify(rebuilt) !== JSON.stringify(values?.quotation?.rows)) {
  formikRef?.current?.setFieldValue("quotation.rows", rebuilt, false);
  }
  }, [quotationData]);
  const quotationRef = useRef(null);
  const [downloading, setDownloading] = useState(false);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={ quotationData}
      validationSchema={quotationSchema(canEditAll)}
      validateOnMount={true}
      enableReinitialize={true}
      validate={(values) =>
        validateYupSchema(values,quotationSchema(),false,{
          serviceConfig: values.serviceConfig,
          isQuotationMode: activeTab === Quotation_SUBTAB.QUOTATION,
          floorRows: sortQuotationRows(floorPriceActiveData?.quotation?.rows || [])
      }).then(() => ({}),yupToFormErrors)}
      onSubmit={(values) => {
        if (!effectivePreview) {
          setIsPreview(true);
          return;
        }
        const nextStatus = canEditAll ? DEMAND_ACTIONS.INITIATE_MARGIN : canEditQuotationOnly? DEMAND_ACTIONS?.GENERATE_QUOTATION : ""
        ConfirmDialog(nextStatus).then((ok) => {
        if (!ok.confirmed) {
            return;
        }
        const actionComment=ok?.comment.trim()   // if confirmed
        
        setIsSubmit(true);
        let reqPayload={}
        const payload = {
          customerLegalName: values.customerLegalName,
          offerValidTill: values.offerValidTill,
          minimumContractPeriod: values.minimumContractPeriod,
          currency: values.currency,
          serviceConfig: values.serviceConfig,
          quotation: values.quotation,
          actionComment:actionComment
        };
        if(nextStatus==DEMAND_ACTIONS.INITIATE_MARGIN){
          reqPayload = {action:nextStatus,stateData: {...payload}}
        }else if(nextStatus==DEMAND_ACTIONS.GENERATE_QUOTATION){
          reqPayload = {action:nextStatus,stateData: {...payload,floorPriceDocUniqueId:quotationData?.floorPriceDocUniqueId}}
        }

        props.addDemandAction(reqPayload, requestId)
        .then((res) => {
          if(res){
            props?.openAlertPopup({
            message: canEditAll ? "Floor pricing submitted successfully." : canEditQuotationOnly? "Quotation sent to the customer successfully." : "",
            image: IMAGES.success
          });
          props.handelServiceDetailapi();
          } else {
            props?.openAlertPopup({
            message: "An error occurred while processing your request. Please try again later.",
            image: IMAGES.error
          });
          }
        })
        .catch((error) => {
          props?.openAlertPopup({
            message: "An error occurred while processing your request. Please try again later.",
            image: IMAGES.error
          });
        })
        .finally(() => {
          setIsSubmit(false);
        });
        })
      }}
    >
      {({ values, setFieldValue, isValid, dirty,setFieldError,setFieldTouched,submitForm }) => {
        const connectionStatus = values?.serviceConfig?.ipAccessStandardConnection?.connectionStatus;
        const connNotSelected = !connectionStatus;
        const grxTurnedOff = values?.serviceConfig?.IpxGrxTransport?.isIpxGrxTransport === "no" || values?.serviceConfig?.IpxGrxTransport?.isIpxGrxTransport === "";
        const sigtranTurnedOff = values?.serviceConfig?.IpxSigtran?.isIpxSigtran === "no" || values?.serviceConfig?.IpxSigtran?.isIpxSigtran === "";
        const diameterTurnedOff = values?.serviceConfig?.IpxDiameter?.isIpxDiameter === "no" || values?.serviceConfig?.IpxDiameter?.isIpxDiameter === "";
        const httpTurnedOff = values?.serviceConfig?.IpxHttp?.isIpxHttp === "no" || values?.serviceConfig?.IpxHttp?.isIpxHttp === "";
        const selectedCurrency = currencyOptions.find((c) => c.value === values.currency);
        const currencySymbol = selectedCurrency?.symbol || "---";
        // helper for pop row index
        const derivePopIndexFromName = (name) => { const m = (name || "").match(/access pop\s*(\d+)/i); return m ? Number(m[1]) - 1 : undefined;};
        // ---- central disable logic ----
        const computeDisableForRow = (row) => {
        const isPopRow =
          row.group === "pops";
        const isGrxBandwidthRow = row.group === "grx-bandwidth";
        const isSigtranRow =
          row.group === "sigtran"||
          /^IPX Sigtran/i.test(row.ipxService || "");
        const isDiameterRow =
          row.group === "diameter"||
          /^IPX Diameter/i.test(row.ipxService || "");
        const isHttpRow =
          row.group === "http"||
          /^IPX Http/i.test(row.ipxService || "");
        // const isSigtranRow =
        //   row.group === "sigtran";
        // const isDiameterRow =
        //   row.group === "diameter";
        const isDnsRow = row.group === "dns";
        // const isLineCardRow =
        //   row.group === "line-card" ||
        //   /per\s*10\s*g\s*line\s*card/i.test(row.ipxService || "");

        const roleDisable = quotationReadOnly;

        // --- POP disable (require BOTH region and portSize) ---
        let popDisable = false;
        if (isPopRow) {
          const popId = row.popId;
          const pop = values.serviceConfig?.ipAccessStandardConnection?.popsDetails?.find(p => p.id === popId);
          const region = pop?.region;
          const portSize = pop?.portSize;
          popDisable = connNotSelected || !(region && portSize);
        }
        // --- GRX disable ---
        let grxDisable = false;
        if (isGrxBandwidthRow) {
          const bandwidthId = row.bandwidthId;
          const bwList = values.serviceConfig?.IpxGrxTransport?.bandwidths || [];
          const isSelected = bwList.some(
            (b) =>b.id === bandwidthId &&b.allocatedBandwidth &&b.allocatedBandwidth.trim() !== "");
          const grxTurnedOff =values.serviceConfig?.IpxGrxTransport.isIpxGrxTransport === "no" || values.serviceConfig?.IpxGrxTransport.isIpxGrxTransport === "";
          grxDisable = grxTurnedOff || !isSelected;
        }

        // --- Sigtran disable ---
        let sigDisable = false;
        if (isSigtranRow) {
          const msuId = row.msuId;
          const msuList = values.serviceConfig?.IpxSigtran?.msus || [];
          const isSelected = msuList.some(
            (msu) =>
              msu.id === msuId && msu.allocatedMsus && msu.allocatedMsus.trim() !== ""
          );
          const sigtranTurnedOff =
            values.serviceConfig?.IpxSigtran?.isIpxSigtran !== "yes";
          sigDisable = sigtranTurnedOff || !isSelected;
        }
        // const sigDisable =
        //   isSigtranRow &&
        //   (values.serviceConfig?.IsIpxSigtran === "no" ||
        //     values.serviceConfig?.IsIpxSigtran === "");

        // --- Diameter disable ---
        let diaDisable = false;
        if (isDiameterRow) {
          const transactionId = row.transactionId;
          const transactionList = values.serviceConfig?.IpxDiameter?.numberOfTransactions || [];
          const isSelected = transactionList.some(
            (transaction) =>
              transaction.id === transactionId && transaction.transaction && transaction.transaction.trim() !== ""
          );
          const diameterTurnedOff =
            values.serviceConfig?.IpxDiameter?.isIpxDiameter !== "yes";
          diaDisable = diameterTurnedOff || !isSelected;
        }
        // --- Http disable ---
        let httpDisable = false;
        if (isHttpRow) {
          const transactionVolumeId = row.transactionVolumeId;
          const transactionVolumeList = values.serviceConfig?.IpxHttp?.transactionVolumes || [];
          const isSelected = transactionVolumeList.some(
            (allocatedTransactionVolumes) =>
              allocatedTransactionVolumes.id === transactionVolumeId && allocatedTransactionVolumes.allocatedTransactionVolumes && allocatedTransactionVolumes.allocatedTransactionVolumes.trim() !== ""
          );
          const httpTurnedOff =
            values.serviceConfig?.IpxHttp?.isIpxHttp !== "yes";
          httpDisable = httpTurnedOff || !isSelected;
        }
        // const diaDisable =
        //   isDiameterRow &&
        //   (values.serviceConfig?.IsIpxDiameter === "no" ||
        //     values.serviceConfig?.IsIpxDiameter === "");
        const dnsDisable = isDnsRow && (values.serviceConfig?.IsIpxDns === "no" || values.serviceConfig?.IsIpxDns === "");
        // --- Line card disable ---
        // const connExisting =
        //   values.serviceConfig?.ipAccessStandardConnection.connectionStatus ===
        //     "existing" ||
        //   values.serviceConfig?.ipAccessStandardConnection.connectionStatus === "";
        // const lineDisable = isLineCardRow && connExisting;

        return (
          roleDisable ||
          effectivePreview ||
          popDisable ||
          grxDisable ||
          sigDisable ||
          diaDisable ||
          httpDisable ||
          dnsDisable
          // ||lineDisable
        );
        };
        return (
          <Form className={styles.form}>  
            {VALID_QUOTATION_STATUSES?.includes(status) && (
              <QuotationStatus
                title={config?.title}
                description={config?.description || quotationData?.comment}
                variant={config?.variant}
              />
            )}
            {/* ------------------- SUMMARY ------------------- */}
             {historyData?.length>1&&
                 <div className={styles.historybtn}>
                 <HistoryPanel onViewQuote={onViewQuote} historyData={historyData} quotationId={quotationData?.id} activeTab={activeTab}/>
                 </div>
                  }
            <section className={styles.card}>
              <div className={styles.historywrapper}>
                <div className={styles.cardTitle}>
                  {activeTab === Quotation_SUBTAB.FLOOR_PRICING ? ACCORDIAN_TITLE.FLOOR_SUMMARY : ACCORDIAN_TITLE.QUOT_SUMMARY}
                  {quotationData?.version && <spn className={styles.version}>V{quotationData?.version}</spn>}
                  <spn className={`${styles.status} ${styles[quotationData?.status]}`}>{toTitleCase(quotationData?.status)}</spn>
                </div>
                 <div className={styles.historypanel}>
                  {quotationData?.createdAt &&<div className={styles.createdwrapper}>
                    <span className={styles.datelabel}>Created On:</span>
                    <span className={styles.datevalue}>{formatDate(quotationData?.createdAt)}</span>
                  </div>}
                {/* {historyData?.length>1&&
                  <HistoryPanel onViewQuote={onViewQuote} historyData={historyData} quotationId={quotationData?.id} activeTab={activeTab}/>
                  } */}
                 </div>
              </div>
              {/* {
                quotationData?.actionComment && quotationData?.actionComment.trim().length > 0 &&
                (<div className={styles.commentText}>
                  comment : {quotationData?.actionComment}
                </div>)
              } */}
              <div className={`${styles.grid4} ${summaryReadOnly && styles.summaryreadonly}`}>
                <div className={styles.wrapperpadding}>
                <TextField
                  name="customerLegalName"
                  label="Customer Legal Name"
                  placeholder="Please Select"
                  isMandatory={!summaryReadOnly}
                  isPreviewMode={effectivePreview || summaryReadOnly}
                  disabled={summaryReadOnly}
                />
                </div>
                <div className={styles.wrapperpadding}>
                {/* <DateTimeTextField
                  name="offerValidTill"
                  label="Offer Valid till"
                  type="date" 
                  isMandatory={!summaryReadOnly}
                  isPreviewMode={effectivePreview || summaryReadOnly}
                  disabled={summaryReadOnly}
                /> */}
                 <DatePickerField
                  name="offerValidTill"
                  label="Offer Valid Till"
                  type="date"
                  isMandatory={!summaryReadOnly}
                  isPreviewMode={effectivePreview || summaryReadOnly}
                  disabled={summaryReadOnly}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/MM/yyyy"
                  labelstyle={styles.labelstyle}
                  />
                </div>
                <div className={styles.wrapperpadding}>
                <SelectField
                  name="minimumContractPeriod"
                  label="Minimum Contract Period"
                  options={minimumContractPeriod}
                  placeholder="Please Select"
                  isMandatory={!summaryReadOnly}
                  isPreviewMode={effectivePreview || summaryReadOnly}
                  disabled={summaryReadOnly}
                />
                </div>
                <div className={styles.wrapperpadding}>
                <SelectField
                  name="currency"
                  label="Currency"
                  placeholder="Please Select"
                  isMandatory={!summaryReadOnly}
                  options={currencyOptions}
                  isPreviewMode={effectivePreview || summaryReadOnly}
                  isDisabled={summaryReadOnly}
                />
                </div>
              </div>
              {
                quotationData?.actionComment && quotationData?.actionComment.trim().length > 0 &&
                (<div className={styles.commentText}>
                  <span className={styles.commentlabel}>Comment</span> 
                  <div className={styles.commentvalue}>{quotationData?.actionComment?.split('\n').map(text => <div>{text}</div>)}</div>
                </div>)
              }
              {/* {!quotationData?.accepted && quotationData?.comment &&
              <>
                <div className={styles.rejection}>Customer Rejection Reason</div>
                <div className={`${styles.grid} ${styles.summaryreadonly}`}>{quotationData?.comment}</div>
              </>} */}
            </section>
            {/* ------------------- SERVICE CONFIG ------------------- */}
            <section className={styles.card}>
              <Accordion accordianType={TYPE.PARENT} title={ACCORDIAN_TITLE.SERVICE_CONFIG}defaultOpen={true}>
                {/* ---------------- POPs ---------------- */}
                <Accordion title={ACCORDIAN_TITLE.IPASC} defaultOpen={true}>
                  <div className={styles.grid2}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.ipAccessStandardConnection.connectionStatus"
                        label="Connection to Vodafone standard PoPs"
                        options={connectionOptions}
                        isPreviewMode={effectivePreview}
                        serviceConfiguration={true}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(newValue, { helpers }) => {
                          helpers.setValue(newValue);
                          const clearedPops = [{ region: "", portSize: "" }];
                          setFieldValue("serviceConfig.ipAccessStandardConnection.popsDetails",clearedPops);
                          // Minimal line-card logic (rest lives in utilities)
                          let rows = buildPopsRows(clearedPops,values?.quotation?.rows,regionOptions);
                          // const isLineCard = (r) => r?.group === "line-card" || /access\s*-\s*per\s*10\s*g\s*line\s*card/i.test(r?.ipxService || "");
                          // const lcIndex = rows.findIndex(isLineCard);
                          // if (lcIndex !== -1) {
                          //   if (newValue === "existing" || newValue === "") {
                          //     rows[lcIndex] = {
                          //       ...rows[lcIndex],
                          //       setupCost: "",
                          //       monthlyCharges: "",
                          //       usageBased: "",
                          //     };
                          //   }
                          // }
                          setFieldValue("quotation.rows", rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                  <FieldArray name="serviceConfig.ipAccessStandardConnection.popsDetails">
                    {(arrayHelpers) => {
                      const pops =values?.serviceConfig?.ipAccessStandardConnection?.popsDetails || [];
                      const count = pops.length;
                      const addPop = () => {
                        const newPop = {id:generateId(),region: "",portSize: ""};
                        arrayHelpers.push(newPop);
                        const next = [...pops, newPop];
                        const rebuild = buildPopsRows(next,values?.quotation?.rows,regionOptions);
                        setFieldValue("quotation.rows", rebuild);
                      };
                      const removePop = (idx) => {
                        if (pops.length === 1) return;
                        arrayHelpers.remove(idx);
                        const next = pops.filter((_, i) => i !== idx);
                        const rebuild = buildPopsRows(next,values.quotation.rows,regionOptions);
                        setFieldValue("quotation.rows", rebuild);
                      };
                      return (
                        <>
                          {pops.map((pop, idx) => (
                            <div className={styles.popRow} key={`pop-${idx}`}>
                              <div className={styles.wrapperpadding}>
                              <SelectField
                                name={`serviceConfig.ipAccessStandardConnection.popsDetails[${idx}].region`}
                                label={`PoP Region`}
                                options={regionOptions}
                                placeholder="Please Select"
                                isPreviewMode={effectivePreview}
                                serviceConfiguration={true}
                                isDisabled={serviceConfigReadOnly || connNotSelected}
                                onChange={(value, { helpers }) => {
                                  helpers.setValue(value);
                                  const nextPops = values.serviceConfig.ipAccessStandardConnection.popsDetails.map((pop, i) =>i === idx ? { ...pop, region: value } : pop);
                                  const rebuild = buildPopsRows(nextPops,values.quotation.rows,regionOptions);
                                  const updated = applyPopRegionChange(values,idx,value);
                                  setFieldValue("serviceConfig.ipAccessStandardConnection.popsDetails",updated.serviceConfig.ipAccessStandardConnection.popsDetails);
                                  setFieldValue("quotation.rows",rebuild);
                                }}
                              />
                              </div>
                              <div className={styles.wrapperpadding}>
                              <SelectField
                                name={`serviceConfig.ipAccessStandardConnection.popsDetails[${idx}].portSize`}
                                label={`PoP Port Size`}
                                options={portSizeOptions}
                                placeholder="Please Select"
                                serviceConfiguration={true}
                                isPreviewMode={effectivePreview}
                                isDisabled={serviceConfigReadOnly || connNotSelected}
                              />
                              </div>
                              {!effectivePreview && canEditAll && !connNotSelected && count > 1 && (
                                <button
                                  type="button"
                                  className={styles.deleteIconButton}
                                  onClick={() => removePop(idx)}
                                  title={`Delete PoP`}
                                  aria-label={`Delete PoP`}
                                >
                                  <img src={IMAGES.remove} alt="delete" className={styles.deleteicon}/>
                                </button>
                              )}
                            </div>
                          ))}
                          {!effectivePreview && canEditAll && !connNotSelected && pops?.length <= 4 && (
                            <button type="button" className={`${styles.btn} ${styles.btnAdd}`} onClick={addPop}>+ Add More</button>
                          )}
                        </>
                      );
                    }}
                  </FieldArray>
                </Accordion>
                {/* ---------------- GRX Transport ---------------- */}
                <Accordion
                  title={ACCORDIAN_TITLE.IPX_GRX_TRANSPORT}
                  defaultOpen={true}
                >
                  <div className={styles.grid3}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IpxGrxTransport.isIpxGrxTransport"
                        label="IPX GRX/Transport"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applyTransportChange(values, value);
                          setFieldValue("serviceConfig.IpxGrxTransport.bandwidths",updated.serviceConfig.IpxGrxTransport.bandwidths);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                  <FieldArray name="serviceConfig.IpxGrxTransport.bandwidths">
                    {(arrayHelpers) => {
                      const list = values?.serviceConfig?.IpxGrxTransport?.bandwidths || [];
                      const count = list.length;
                      const addBandwidth = () => {
                        const newBw = {id: generateId(),allocatedBandwidth: ""};
                        arrayHelpers.push(newBw);
                        const next = [...list, newBw];
                        const rebuilt = buildGrxBandwidthRows(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      const removeBandwidth = (idx) => {
                        if (list.length === 0) return;
                        arrayHelpers.remove(idx);
                        const next = list.filter((_, i) => i !== idx);
                        const rebuilt = buildGrxBandwidthRows(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      return (
                        <>
                          <div className={styles.bandwidthRow}>
                            {list.map((bw, idx) => (
                              <div
                                className={styles.bandwidthItem}
                                key={bw.id}
                              >
                                <div className={styles.wrapperpadding}>
                                  <TextField
                                    name={`serviceConfig.IpxGrxTransport.bandwidths[${idx}].allocatedBandwidth`}
                                    label="Bandwidth"
                                    placeholder="Enter "
                                    type="text"
                                    disabled={serviceConfigReadOnly || grxTurnedOff}
                                    onChange={(value) => {
                                      if (grxTurnedOff) return;
                                      const next = [...list];
                                      next[idx] = {
                                        ...next[idx],
                                        allocatedBandwidth: value,
                                      };
                                      setFieldValue("serviceConfig.IpxGrxTransport.bandwidths",next);
                                      const rebuilt = buildGrxBandwidthRows(next,values.quotation.rows);
                                      setFieldValue("quotation.rows", rebuilt);
                                    }}
                                  />
                                </div>
                                {!effectivePreview &&canEditAll &&!grxTurnedOff &&count > 1 && (
                                    <button type="button" className={styles.deleteIconButton} onClick={() => removeBandwidth(idx)}>
                                      <img src={IMAGES.remove}alt="delete" className={styles.deleteicon}/>
                                    </button>
                                    // <span className={styles.deletepopicon} onClick={() => removeBandwidth(idx)}role="button"aria-label="Remove">✕</span>
                                  )}
                              </div>
                            ))}
                          </div>
                          {!effectivePreview && canEditAll && !grxTurnedOff && list?.length <=4 && (
                            <button type="button" className={`${styles.btn} ${styles.btnAdd}`} onClick={addBandwidth}>+ Add More</button>
                          )}
                        </>
                      );
                    }}
                  </FieldArray>
                </Accordion>
                {/* ---------------- IPX Sigtran ---------------- */}
                <Accordion
                  title={ACCORDIAN_TITLE.IPX_SIGTRAN}
                  defaultOpen={true}
                >
                  <div className={styles.grid3}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IpxSigtran.isIpxSigtran"
                        label="IPX Sigtran"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applySigtranChange(values, value);
                          setFieldValue("serviceConfig.IpxSigtran.msus",updated.serviceConfig.IpxSigtran.msus);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                  <FieldArray name="serviceConfig.IpxSigtran.msus">
                    {(arrayHelpers) => {
                      const list = values?.serviceConfig?.IpxSigtran?.msus || [];
                      const count = list.length;
                      const addMsu = () => {
                        const newMsu = {id: generateId(),allocatedMsus: ""};
                        arrayHelpers.push(newMsu);
                        const next = [...list, newMsu];
                        const rebuilt = buildSigtranMsusRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      const removeMsu = (idx) => {
                        if (list.length === 0) return;
                        arrayHelpers.remove(idx);
                        const next = list.filter((_, i) => i !== idx);
                        const rebuilt = buildSigtranMsusRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      return (
                        <>
                          <div className={styles.bandwidthRow}>
                            {list.map((bw, idx) => (
                              <div
                                className={styles.bandwidthItem}
                                key={bw.id}
                              >
                                <div className={styles.wrapperpadding}>
                                  <TextField
                                    name={`serviceConfig.IpxSigtran.msus[${idx}].allocatedMsus`}
                                    label="MSUs"
                                    placeholder="Enter value"
                                    type="text"
                                    disabled={serviceConfigReadOnly || sigtranTurnedOff}
                                    onChange={(value) => {
                                      if (sigtranTurnedOff) return;
                                      const next = [...list];
                                      next[idx] = {
                                        ...next[idx],
                                        allocatedMsus: value,
                                      };
                                      setFieldValue("serviceConfig.IpxSigtran.msus",next);
                                      const rebuilt = buildSigtranMsusRow(next,values.quotation.rows);
                                      setFieldValue("quotation.rows", rebuilt);
                                    }}
                                  />
                                </div>
                                {!effectivePreview &&canEditAll &&!sigtranTurnedOff &&count > 1 && (
                                    <button type="button" className={styles.deleteIconButton} onClick={() => removeMsu(idx)}>
                                      <img src={IMAGES.remove}alt="delete" className={styles.deleteicon}/>
                                    </button>
                                    // <span className={styles.deletepopicon} onClick={() => removeMsu(idx)}role="button"aria-label="Remove">✕</span>
                                  )}
                              </div>
                            ))}
                          </div>
                          {!effectivePreview && canEditAll && !sigtranTurnedOff && list?.length <=4 && (
                            <button type="button" className={`${styles.btn} ${styles.btnAdd}`} onClick={addMsu}>+ Add More</button>
                          )}
                        </>
                      );
                    }}
                  </FieldArray>
                </Accordion>
                {/* ---------------- IPX DIAMETER ---------------- */}
                <Accordion
                  title={ACCORDIAN_TITLE.IPX_DIAMETER}
                  defaultOpen={true}
                >
                  <div className={styles.grid3}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IpxDiameter.isIpxDiameter"
                        label="IPX Diameter"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applyDiameterChange(values, value);
                          setFieldValue("serviceConfig.IpxDiameter.numberOfTransactions",updated.serviceConfig.IpxDiameter.numberOfTransactions);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                  <FieldArray name="serviceConfig.IpxDiameter.numberOfTransactions">
                    {(arrayHelpers) => {
                      const list = values?.serviceConfig?.IpxDiameter?.numberOfTransactions || [];
                      const count = list.length;
                      const addTransaction = () => {
                        const newTransaction = {id: generateId(),transaction: ""};
                        arrayHelpers.push(newTransaction);
                        const next = [...list, newTransaction];
                        const rebuilt = buildDiameterTransactionRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      const removeTransaction = (idx) => {
                        if (list.length === 0) return;
                        arrayHelpers.remove(idx);
                        const next = list.filter((_, i) => i !== idx);
                        const rebuilt = buildDiameterTransactionRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      return (
                        <>
                          <div className={styles.bandwidthRow}>
                            {list.map((bw, idx) => (
                              <div
                                className={styles.bandwidthItem}
                                key={bw.id}
                              >
                                <div className={styles.wrapperpadding}>
                                  <TextField
                                    name={`serviceConfig.IpxDiameter.numberOfTransactions[${idx}].transaction`}
                                    label="No. of Transactions"
                                    placeholder="Enter value"
                                    type="text"
                                    disabled={serviceConfigReadOnly || diameterTurnedOff}
                                    onChange={(value) => {
                                      if (diameterTurnedOff) return;
                                      const next = [...list];
                                      next[idx] = {
                                        ...next[idx],
                                        transaction: value,
                                      };
                                      setFieldValue("serviceConfig.IpxDiameter.numberOfTransactions",next);
                                      const rebuilt = buildDiameterTransactionRow(next,values.quotation.rows);
                                      setFieldValue("quotation.rows", rebuilt);
                                    }}
                                  />
                                </div>
                                {!effectivePreview &&canEditAll &&!diameterTurnedOff &&count > 1 && (
                                    <button type="button" className={styles.deleteIconButton} onClick={() => removeTransaction(idx)}>
                                      <img src={IMAGES.remove}alt="delete" className={styles.deleteicon}/>
                                    </button>
                                    // <span className={styles.deletepopicon} onClick={() => removeTransaction(idx)}role="button"aria-label="Remove">✕</span>
                                  )}
                              </div>
                            ))}
                          </div>
                          {!effectivePreview && canEditAll && !diameterTurnedOff && list?.length <=4 && (
                            <button type="button" className={`${styles.btn} ${styles.btnAdd}`} onClick={addTransaction}>+ Add More</button>
                          )}
                        </>
                      );
                    }}
                  </FieldArray>
                </Accordion>
                {/* ---------------- IPX Http ---------------- */}
                <Accordion
                  title={ACCORDIAN_TITLE.IPX_HTTP}
                  defaultOpen={true}
                >
                  <div className={styles.grid3}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IpxHttp.isIpxHttp"
                        label="IPX HTTP2"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applyHttpChange(values, value);
                          setFieldValue("serviceConfig.IpxHttp.transactionVolumes",updated.serviceConfig.IpxHttp.transactionVolumes);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                  <FieldArray name="serviceConfig.IpxHttp.transactionVolumes">
                    {(arrayHelpers) => {
                      const list = values?.serviceConfig?.IpxHttp?.transactionVolumes || [];
                      const count = list.length;
                      const addAllocatedTransactionVolume = () => {
                        const newAllocatedTransactionVolume = {id: generateId(),allocatedTransactionVolumes: ""};
                        arrayHelpers.push(newAllocatedTransactionVolume);
                        const next = [...list, newAllocatedTransactionVolume];
                        const rebuilt = buildHttpRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      const removeAllocatedTransactionVolume = (idx) => {
                        if (list.length === 0) return;
                        arrayHelpers.remove(idx);
                        const next = list.filter((_, i) => i !== idx);
                        const rebuilt = buildHttpRow(next,values.quotation.rows);
                        setFieldValue("quotation.rows", rebuilt);
                      };
                      return (
                        <>
                          <div className={styles.bandwidthRow}>
                            {list.map((bw, idx) => (
                              <div
                                className={styles.bandwidthItem}
                                key={bw.id}
                              >
                                <div className={styles.wrapperpadding}>
                                  <TextField
                                    name={`serviceConfig.IpxHttp.transactionVolumes[${idx}].allocatedTransactionVolumes`}
                                    label="Transaction Volumes"
                                    placeholder="Enter value"
                                    type="text"
                                    disabled={serviceConfigReadOnly || httpTurnedOff}
                                    onChange={(value) => {
                                      if (httpTurnedOff) return;
                                      const next = [...list];
                                      next[idx] = {
                                        ...next[idx],
                                        allocatedTransactionVolumes: value,
                                      };
                                      setFieldValue("serviceConfig.IpxHttp.transactionVolumes",next);
                                      const rebuilt = buildHttpRow(next,values.quotation.rows);
                                      setFieldValue("quotation.rows", rebuilt);
                                    }}
                                  />
                                </div>
                                {!effectivePreview &&canEditAll &&!httpTurnedOff &&count > 1 && (
                                    <button type="button" className={styles.deleteIconButton} onClick={() => removeAllocatedTransactionVolume(idx)}>
                                      <img src={IMAGES.remove}alt="delete" className={styles.deleteicon}/>
                                    </button>
                                    // <span className={styles.deletepopicon} onClick={() => removeTransaction(idx)}role="button"aria-label="Remove">✕</span>
                                  )}
                              </div>
                            ))}
                          </div>
                          {!effectivePreview && canEditAll && !httpTurnedOff && list?.length <=4 && (
                            <button type="button" className={`${styles.btn} ${styles.btnAdd}`} onClick={addAllocatedTransactionVolume}>+ Add More</button>
                          )}
                        </>
                      );
                    }}
                  </FieldArray>
                </Accordion>
                {/* ---------------- SIGTRAN / DIAMETER ---------------- */}
                {/* <div className={styles.subSection}>
                  <div className={styles.grid2}>
                    <div className={styles.field}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IsIpxSigtran"
                        label="IPX Sigtran"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applySigtranChange(values, value);
                          setFieldValue("serviceConfig.IsIpxSigtran", updated.serviceConfig?.IsIpxSigtran);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                    <div className={styles.field}>
                      <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IsIpxDiameter"
                        label="IPX Diameter"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applyDiameterChange(values, value);
                          setFieldValue("serviceConfig.IsIpxDiameter",updated?.serviceConfig?.IsIpxDiameter);
                          setFieldValue("quotation.rows",updated.quotation.rows);
                        }}
                      />
                      </div>
                    </div>
                  </div>
                </div> */}
                <Accordion title={ACCORDIAN_TITLE.IPX_DNS} defaultOpen={true}>
                  <div className={styles.grid3}>
                    <div className={`${styles.field} ${styles.fullRow}`}>
                      <div className={styles.wrapperpadding}>
                        <SelectField
                          name="serviceConfig.IsIpxDns"
                          label="IPX DNS Standalone"
                          options={grxTransportOptions}
                          serviceConfiguration={true}
                          isPreviewMode={effectivePreview}
                          isDisabled={serviceConfigReadOnly}
                          placeholder="Please Select"
                          onChange={(value, { helpers }) => {
                            helpers.setValue(value);
                            const updated = applyDnsChange(values, value);
                            setFieldValue("serviceConfig.IsIpxDns", updated.serviceConfig?.IsIpxDns);
                            setFieldValue("quotation.rows", updated.quotation.rows);                        
                            if (value !== "yes") {
                              const dnsRowIndex = values.quotation.rows.findIndex((row) => row.group === "dns");
                              if (dnsRowIndex !== -1) {
                                ["setupCost", "monthlyCharges", "usageBased"].forEach((field) => {
                                  setFieldError(`quotation.rows[${dnsRowIndex}].${field}`, undefined);
                                  setFieldTouched(
                                    `quotation.rows[${dnsRowIndex}].${field}`,
                                    false,
                                    false
                                  );
                                });
                              }
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion>
                {/* <div className={styles.subSection}>
                  <div className={styles.field}>
                    <div className={styles.wrapperpadding}>
                      <SelectField
                        name="serviceConfig.IsIpxDns"
                        label="IPX DNS Standalone"
                        options={grxTransportOptions}
                        serviceConfiguration={true}
                        isPreviewMode={effectivePreview}
                        isDisabled={serviceConfigReadOnly}
                        placeholder="Please Select"
                        onChange={(value, { helpers }) => {
                          helpers.setValue(value);
                          const updated = applyDnsChange(values, value);
                          setFieldValue("serviceConfig.IsIpxDns", updated.serviceConfig?.IsIpxDns);
                          setFieldValue("quotation.rows", updated.quotation.rows);
                        }}
                      />
                    </div>
                  </div>
                </div> */}
                {values?.serviceConfig?.IpxGrxTransport?.isIpxGrxTransport===SELECTION_VALUES.NO && values.serviceConfig?.IpxSigtran?.isIpxSigtran === SELECTION_VALUES.NO && values.serviceConfig?.IpxDiameter?.isIpxDiameter === SELECTION_VALUES.NO && values.serviceConfig?.IpxHttp?.isIpxHttp === SELECTION_VALUES.NO && values.serviceConfig?.IsIpxDns === SELECTION_VALUES.NO &&
                <div className={styles.error}>At least one service type must be marked as “Yes” to create a floor price.</div>}
              </Accordion>
            </section>

            {/* ------------------- QUOTATION TABLE ------------------- */}
            <section className={styles.card}>
              <Accordion accordianType={TYPE.PARENT} title={activeTab === Quotation_SUBTAB.FLOOR_PRICING ? ACCORDIAN_TITLE.FLOOR_SUMMARY : ACCORDIAN_TITLE.QUOT_SUMMARY} defaultOpen={true}>
                <div className={styles.table}>
                  <div className={`${styles.tr} ${styles.th}`}>
                    <div className={styles.tableheadertxt}>IPX Services</div>
                    <div className={styles.tableheadertxt}>Setup / Implementation fee ( {currencySymbol} )</div>
                    <div className={styles.tableheadertxt}>Monthly Charges ( {currencySymbol} )</div>
                    <div className={styles.tableheadertxt}>Usage Based ( {currencySymbol} )</div>
                  </div>
                  {sortQuotationRows(values?.quotation?.rows)?.map((row, idx) => {
                    const disabled = computeDisableForRow(row);
                    return (
                      <div className={`${styles.tr} ${effectivePreview ? idx % 2 === 0 ? styles.rowWhite : styles.rowGray : ""}`} key={`row-${idx}`}>
                        <div className={styles.td}><div className={styles.textCell}>{row.ipxService}</div></div>
                        <div className={styles.td}>
                          <div className={styles.tableInputWrapper}>
                            <TextField
                              name={`quotation.rows[${idx}].setupCost`}
                              type="text"
                              placeholder="Enter here"
                              disabled={disabled}
                              // inputRight={"inputRight"}
                              isPreviewMode={effectivePreview}
                            />
                          </div>
                        </div>
                        <div className={styles.td}>
                          <div className={styles.tableInputWrapper}>
                            <TextField
                              name={`quotation.rows[${idx}].monthlyCharges`}
                              type="text"
                              placeholder="Enter here"
                              disabled={disabled}
                              // inputRight={"inputRight"}
                              isPreviewMode={effectivePreview}
                            />
                          </div>
                        </div>
                        <div className={styles.td}>
                          <div className={styles.tableInputWrapper}>
                            <TextField
                              name={`quotation.rows[${idx}].usageBased`}
                              type="text"
                              placeholder="Enter here"
                              disabled={disabled}
                              // inputRight={"inputRight"}
                              isPreviewMode={effectivePreview}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={styles.note} role="note">
                  <div className={styles.noteellipsis}>
                    <img className={styles.noteinfo} src={IMAGES.infoCircle} alt="Information icon"/>
                    <span className={styles.noteText}>This offer is to be kept strictly confidential between the parties and subject to final commercial approval.</span>
                  </div>
                </div>
              </Accordion>
              {isWorkflowReadOnly && (
              <div className={`${styles.footerwrappercust}`}>
                {activeConfig?.canDownload && (
                  <div className={styles.downloadwrapper} onClick={() => generateQuotationPDF(values, setDownloading, regionOptions, {title: activeConfig.title,})}>
                    <img src={IMAGES.downloadlogo} alt="download" className={styles.downloadlogo}/>
                    <span className={styles.downloadtxt}>{downloading ? "Preparing PDF..." : "Download (PDF)"}</span>
                  </div>)}
                {actionStatus===ACTION_STATUS.QUOTATION_CUSTOMER_APPROVAL_INITIATED && isCustomer &&
                <div className={styles.footer}>
                  <Submit type="button" className={styles.rejectquot} onClick={() =>  setDecisionModal({ action: DEMAND_ACTIONS.REJECT_QUOTATION })} title={"Send Back"}/>
                  <Submit type="button" style={`${styles.accetquot}`} title={" Accept"} onClick={() => setDecisionModal({ action: DEMAND_ACTIONS.APPROVE_QUOTATION })}/>
                </div>}
              </div>
              )}
            </section>

            {/* ------------------- FOOTER ------------------- */}
            {(canEditAll && activeTab === Quotation_SUBTAB.FLOOR_PRICING && InitialData?.id === quotationData?.id ) ? (
                <div className={`${styles.footerwrapper}`}>
                  <div className={`${styles.footer}`}>
                    {effectivePreview && <BackButton className={styles.backButton} closePopup={() => setIsPreview(false)} title={"Edit"} disabled = {isSubmit}/>}
                    <Submit title={effectivePreview ? "Send FP for Quotation" : "Preview"}isSubmitting={isSubmit}/>
                  </div>
                </div>
            ) : null}
             {(canEditQuotationOnly && activeTab === Quotation_SUBTAB.QUOTATION && InitialData?.id === quotationData?.id) ? (
                <div className={`${styles.footerwrapper}`}>
                  <div className={`${styles.footer}`}>
                    {effectivePreview && <BackButton className={styles.backButton} closePopup={() => setIsPreview(false)} title={"Update Quotation"}  disabled = {isSubmit}/>}
                    <Submit title={effectivePreview ? "Send to Customer" : "Preview"}isSubmitting={isSubmit}/>
                  </div>
                </div>
            ) : null}
            {/* ---------- Decision Modal (Accept / Reject) ---------- */}
            {decisionModal && (
              <DecisionModal
                action={decisionModal.action}
                requestId={requestId}
                quotationdata = {values}
                addDemandAction={props?.addDemandAction}
                openAlertPopup={props.openAlertPopup}
                handelServiceDetailapi={props.handelServiceDetailapi}
                setDecisionModal={setDecisionModal}
              />
            )}
          </Form>
        );
      }}
    </Formik>
  );
}

const mapStateToProps = (state) => {
  return {
    myRights : state.myRights.myRights,
    activeTab :state.tabReducer.activeSecondaryTab,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);